module.exports = __webpack_public_path__ + "static/media/bootstrap.5c25bd65.svg";